import { EXCHANGE_STORE_NAME, IStore } from './store';
import { useDispatch, useSelector } from 'react-redux';
import { LocationType, useFrontendSubscriptionStatus } from '@cmctechnology/webinvest-store-frontend';
import { useFrontendLocationSelector } from '@cmctechnology/webinvest-store-frontend/dist/js/hooks';
import { API_NAMES } from './actions';
import { exchangeActions } from './index';
import { useEffect, useState } from 'react';
import { Exchange } from '@cmctechnology/webinvest-constants';

export const useExchangeSelector = (location: LocationType) => {
  const country = <Exchange>useFrontendLocationSelector(location, EXCHANGE_STORE_NAME, API_NAMES.MarketStatusGet2);
  return useSelector((store: IStore) => store.exchange[country]);
};

export const useExchange = (location: LocationType, exchange: Exchange) => {
  const currentExchange = useSelector((store: IStore) => store.exchange[exchange]);
  const dispatch = useDispatch();
  const marketStatusGet2Status = useFrontendSubscriptionStatus(EXCHANGE_STORE_NAME, API_NAMES.MarketStatusGet2, exchange);
  const { polling } = useFrontendSubscriptionStatus(EXCHANGE_STORE_NAME, API_NAMES.MarketStatusGet2, exchange);
  const [prevRequest, setPrevRequest] = useState(exchange);

  useEffect(() => {
    if (exchange) {
      dispatch<any>(exchangeActions.subscribe(location, exchange));

      if (exchange !== prevRequest) {
        dispatch<any>(exchangeActions.subscribe(location, exchange));
        dispatch<any>(exchangeActions.unsubscribe(location, prevRequest));
        setPrevRequest(exchange);
      }
    }

    return () => {
      if (exchange) {
        dispatch<any>(exchangeActions.unsubscribe(location, exchange));
      }
    };
  }, [exchange]);

  return {
    loading: marketStatusGet2Status.fetching && !currentExchange,
    polling,
    error: marketStatusGet2Status.error,
    data: currentExchange,
    fetching: marketStatusGet2Status.fetching
  };
};
